import React, { useState } from 'react';
import Panel from 'Components/Panel/Panel'
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import Order from './Order/Order';
import ServiceOrderItem from './ServiceOrderItem/ServiceOrderItem';

const ServiceItem = () => {
    const [serviceOrderIdSelected, setOrderIdSelected] = useState([]);

    return (
        <LayoutDefault>

            <Panel style={{
                display: 'flex', flexDirection: 'row', height: '100%', width: '100%'
            }}>
                <Order serviceOrderIdSelected={serviceOrderIdSelected}
                    onUpdateServiceOrderId={setOrderIdSelected}
                />
                <ServiceOrderItem
                    serviceOrderIdSelected={serviceOrderIdSelected}
                />
            </Panel>
        </LayoutDefault>

    );

}

export default ServiceItem;